import moment from 'moment'
import React, { useContext, useEffect, useState } from 'react'
import HeaderTabLayout from '../../../components/HeaderTabLayout'
// import OutlinedInput from '@mui/material/OutlinedInput'
import Layout from '../../../components/Layout'
import CustomAddForm from '../../../components/version-4/MasterForms/CustomAddForm'
import { useTrainingCategory } from '../../../hooks/Others/LearningAndDevelopment/useTrainingCategory'
import { useTrainingCategoryContent } from '../../../hooks/Others/LearningAndDevelopment/useTrainingCategoryContent'
import { ROUTES } from '../../../shared/constants'
import { OtherContext } from '../../../context api/Others/OtherContext'
import { useContentQuestion } from '../../../hooks/Others/LearningAndDevelopment/useContentQuestion'
import { Box, Grid, Typography } from '@material-ui/core'
import CustomHeading from '../../../components/CustomHeading'
import { CustomInput, CustomSelect } from '../../../components/CustomForm'

import CustomButton from '../../../components/CustomButton'
import { Add, Delete } from '@material-ui/icons'
import { Select, MenuItem, FormControl, InputLabel } from '@material-ui/core'

export default function AddQuiz({ quiz }) {
  const { addContentQuestion, loading, updateContentQuestion } = useContentQuestion()
  const { getAllTrainingCategories } = useTrainingCategory()
  const { getAllTrainingCategoryContent } = useTrainingCategoryContent()
  const { trainingCategories, trainingCategoryContents } = useContext(OtherContext)
  const [questions, setQuestions] = useState([{ question: '', questionType: 'MCQ', options: [], correctAnswer: [] }])
  const [contentQuestionData, setContentQuestionData] = useState({
    name: '',
    trainingCategory: '',
    trainingCategoryContent: '',
    startDate: new Date(),
    expiryDate: moment().add(1, 'month'),
    active: true,
  })
  const [selected, setSelected] = React.useState([])
  useEffect(() => {
    getAllTrainingCategories()
  }, [])

  useEffect(() => {
    if (contentQuestionData.trainingCategory) {
      getAllTrainingCategoryContent({ trainingCategory: contentQuestionData.trainingCategory })
    }
  }, [contentQuestionData.trainingCategory])

  let handleChange = (i, e, options, optionsIndex) => {
    let newFormValues = [...questions]
    if (options) {
      newFormValues[i]['options'][optionsIndex] = e.target.value
      // console.log('manas arora', e.target.value)
      setQuestions(newFormValues)
    } else {
      newFormValues[i][e.target.name] = e.target.value
      setQuestions(newFormValues)
    }
  }

  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: 48 * 4.5 + 8,
        width: 300,
      },
    },
  }

  let handleSelectAnswers = (i, e) => {
    let newFormValues = [...questions]
    newFormValues[i]['correctAnswer'] = e.target.value
    setQuestions(newFormValues)
  }

  let addFormFields = () => {
    console.log(questions.at(-1))
    const lastQuestion = questions.at(-1)
    if(lastQuestion.options[0] == '' || lastQuestion.options[1] == '' || lastQuestion.options[2] == '' || lastQuestion.options[3] == '' || lastQuestion.correctAnswer == ''){
      //Add Pop up here
    }else{
      setQuestions([...questions, { question: '', questionType: 'MCQ', options: [], correctAnswer: [] }])
    }
    
  }

  let removeFormFields = (i) => {
    let newFormValues = [...questions]
    // console.log('Manas', ...questions, i)
    newFormValues.splice(i, 1)
    setQuestions(newFormValues)
  }

  const inputValues = [
    { label: 'Assesment Name', value: contentQuestionData.name, name: 'name' },
    { label: 'Training Category', value: contentQuestionData.trainingCategory, name: 'trainingCategory', options: trainingCategories, fieldName: 'name', fieldValue: '_id' },
    {
      label: 'Training Category Content',
      value: contentQuestionData.trainingCategoryContent,
      name: 'trainingCategoryContent',
      options: trainingCategoryContents,
      fieldName: 'name',
      fieldValue: '_id',
      disabled: !contentQuestionData.trainingCategory,
    },
    { label: 'Start Date', value: contentQuestionData.startDate, name: 'startDate', type: 'DATE', minDate: contentQuestionData.startDate },
    { label: 'Expiry Date', value: contentQuestionData.expiryDate, name: 'expiryDate', type: 'DATE', minDate: contentQuestionData.startDate },
  ]

  const handleContentQuestion = async () => {
    if (quiz) {
      updateContentQuestion({ ...contentQuestionData, contentQuestionId: quiz._id, questions })
    } else {
      addContentQuestion({
        ...contentQuestionData,
        questions: questions,
        totalQuestions: questions.length,
      })
    }
  }

  useEffect(() => {
    if (quiz) {
      setContentQuestionData({ ...quiz, trainingCategory: quiz.trainingCategory._id, trainingCategoryContent: quiz.trainingCategoryContent._id })
      setQuestions(quiz.questions)
    }
  }, [quiz])

  var disabled = false
  questions.forEach((ques) => {
    if (ques.correctAnswer.length > 0 && ques.options.length > 1 && ques.question) {
      disabled = false
    } else {
      disabled = true
    }
  })

  return (
    <Layout heading={'Add Assesment'} heading2={quiz ? 'Edit' : 'Add'} url1={ROUTES.ALL_CONTENTQUESTION} none>
      <HeaderTabLayout
        heading={`${quiz ? 'Edit' : 'Add'} ${'Assesment'}`}
        state={contentQuestionData} setState={setContentQuestionData} 
        content={
          <div>
            <CustomAddForm state={contentQuestionData} setState={setContentQuestionData} data={inputValues} />
            {questions.map((item, index1) => {
              return (
                <React.Fragment>
                  <Box display="flex" justifyContent="space-between" marginTop="40px" alignItems="center">
                    <CustomHeading heading={`Question ${index1 + 1}`} />
                  </Box>
                  <CustomInput label="Question" value={item.question} name="question" onChange={(e) => handleChange(index1, e)} fullWidth />
                  <CustomSelect value={item.questionType} label="Question Type" options={['MCQ', 'BOOLEAN']} onChange={(e) => handleChange(index1, e)} name="questionType" />
                  <br />
                  <br />
                  <div>
                    <Grid item lg={5}>
                      <Typography style={{ fontWeight: 600, fontSize: '14px' }}>Options</Typography>​
                      <CustomInput label="First Option" value={item.options[0]} name="options" onChange={(e) => handleChange(index1, e, 'options', 0)} noValidate={true} />
                      <CustomInput label="Second Option" value={item.options[1]} name="options" onChange={(e) => handleChange(index1, e, 'options', 1)} noValidate={true} />
                      <CustomInput label="Third Option" value={item.options[2]} name="options" onChange={(e) => handleChange(index1, e, 'options', 2)} noValidate={true} />
                      <CustomInput label="Fourth Option" value={item.options[3]} name="options" onChange={(e) => handleChange(index1, e, 'options', 3)} noValidate={true} />
                    </Grid>
                  </div>
                  <br />
                  <br />
                  {item.questionType === 'BOOLEAN' ? (
                    <div>
                      {/* <Typography style={{ fontWeight: 600, fontSize: '14px' }}>Correct Answer</Typography>​ */}
                      <CustomSelect
                        style={{ width: 350 }}
                        name="correctAnswer"
                        value={item.correctAnswer}
                        options={item.options}
                        form={questions}
                        label="Correct Answer"
                        onChange={(e) => {
                          let newFormValues = [...questions]
                          newFormValues[index1]['correctAnswer'] = []
                          newFormValues[index1]['correctAnswer'][0] = e.target.value
                          setQuestions(newFormValues)
                        }}
                        disabled={item.options.length === 0}
                      />
                      <br />
                    </div>
                  ) : (
                    <FormControl sx={{ m: 1, width: 300 }}>
                      <Typography style={{ fontWeight: 600, fontSize: '14px' }}>Correct Answers</Typography>
                      <Select
                        style={{ width: 350 }}
                        name="correctAnswer"
                        labelId="correctAnswer"
                        id="correctAnswer"
                        multiple
                        value={item.correctAnswer}
                        onChange={(e) => {
                          handleSelectAnswers(index1, e)
                        }}
                        MenuProps={MenuProps}
                        disabled={item.options.length === 0}
                      >
                        {item.options.map((val) => {
                          return <MenuItem value={val}>{val}</MenuItem>
                        })}
                      </Select>
                      <br />
                    </FormControl>
                  )}
                  <Box display="flex" justifyContent="center">
                    {questions.length - 1 === index1 && (
                      <Box width="20%">
                        <CustomButton text="Add Question" icon={<Add />} handleSubmit={addFormFields} />
                      </Box>
                    )}
                    {questions.length !== 1 ? (
                      <Box width="20%">
                        <CustomButton text="Remove Question" handleSubmit={() => removeFormFields(index1)} icon={<Delete />} />
                      </Box>
                    ) : null}
                  </Box>
                </React.Fragment>
              )
            })}
          </div>
        }
        addContent={handleContentQuestion}
        redirect={ROUTES.ALL_CONTENTQUESTION}
        loading={loading}
        buttonDisabled={disabled}
      />
      {console.log('Manas', contentQuestionData, questions, disabled)}
    </Layout>
  )
}
